import { HEADING_FONT_SIZES, PARAGRAPH_FONT_SIZE } from "./../../ricos-styles/theme-constants.js";
const getBlockDefaultFontSize = (headingLevel) => parseFloat(
  headingLevel ? HEADING_FONT_SIZES[`h${headingLevel}`] : PARAGRAPH_FONT_SIZE
);
export {
  getBlockDefaultFontSize
};
//# sourceMappingURL=get-block-default-font-size.js.map
